module.exports = __webpack_public_path__ + "img/Best of USA rot.f065da66.jpg";